import React,{ useEffect, useState } from 'react';
import { Drawer, List } from 'antd-mobile';
import { CheckCircleTwoTone } from '@ant-design/icons';



const MobileDrawer=(props)=>{
  const [sidebar, setsidebar] = useState('')
  const { fullHeight } = props;

  const drawerStyles = {
    content: {
      maxWidth: '80%',
      margin: `${fullHeight ? '10px' : '100px'} auto`,
      '@media (max-width: 768px)': {
        width: '95%',
      }
    },
    sidebar: {
      backgroundColor: 'white',
      width: '250px'
    }
  };
  
  useEffect(() => {
    let values = props.form.getFieldsValue();

    const aa = (<List style={drawerStyles.sidebar}>
      {props.list.map((i, index) => {
        let obj = values[i.slugValue]
        let flag = false;
        if(obj != undefined && obj.answer != undefined){
          flag = true
        }

        return (<List.Item  key={index}
          onClick={()=>{
            if(props.setactiveIndex){
              props.setactiveIndex(index)
            }
          }}
          multipleLine
        ><CheckCircleTwoTone twoToneColor={flag == true ?'#31c0d4' : '#c7c5c5eb'} style={flag == true ? {marginRight:'20px', color:'red'} : {marginRight:'20px'}}/>
          {i.questionTitle}</List.Item>);
      })}
    </List>);
    setsidebar(aa)
  },[props.onOpenChange])

  return(
    <Drawer
      className="my-drawer"
      style={{ minHeight: document.documentElement.clientHeight }}
      contentStyle={drawerStyles.content}
      sidebar={sidebar}
      open={props.drawerOpen}
      onOpenChange={props.onOpenChange}
      sidebarStyle={drawerStyles.sidebar}
      position={'right'}
    >
      {props.children}
    </Drawer>
  )
}

export default MobileDrawer;